module.exports = __webpack_public_path__ + "static/img/lasphub.4551f42.png";


//////////////////
// WEBPACK FOOTER
// ./static/lasphub.png
// module id = 0e2u
// module chunks = 25